module.exports = __webpack_public_path__ + "fonts/customFactor_70x70.bd02d9064a3ef81834d8d9d5c3a49646.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/customFactor_70x70.png
// module id = 727
// module chunks = 9